import { createUseStyles } from "react-jss";
import {colors} from "../../constants/colors";
import checkIcon from "../../resources/images/check-sort-icon.svg";
import greyCheckIcon from "../../resources/images/check-grey-icon.svg";

const styles = createUseStyles(theme => ({
  checkboxWrapper: {
    display: "flex",
    height: "min-content",
    alignItems: "center",
    "& input": {
      appearance: "none"
    }
  },
  checkbox: {
    display: "flex",
    width: "20px",
    height: "20px",
    accentColor: colors.mediumBlue,    
    backgroundColor: `${colors.white} !important`,      
    borderRadius: "6px ",
    border: `1px solid ${colors.darkGrey}`,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: `${theme.modal.optionHover.backgroundColor} !important`, 
      border: "1px solid " + theme.colors.primary,
    },
  },
  checked: {
    backgroundImage: `url(${checkIcon})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",    
    backgroundColor: `${colors.mediumBlue} !important`,    
    border: `1px solid ${colors.darkBlue}`
  },
  checkedDisabled: {
    backgroundImage: `url(${greyCheckIcon})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",    
    backgroundColor: `${colors.mediumBlue} !important`,    
    border: `1px solid ${colors.darkBlue}`,
    "&:hover": {
      backgroundColor: `${colors.mediumBlue} !important`,    
      border: `1px solid ${colors.darkBlue}`,
      cursor: "default",
    },
  },
  label: {
    height: "auto",
    marginLeft: "10px",
    display: "flex",
    alignItems: "center",
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "20px",
    color: colors.grey
  },
  disabledLabel: {
    height: "auto",
    marginLeft: "10px",
    display: "flex",
    alignItems: "center",
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "20px",
    color: colors.inactiveGrey
  },
  icon: {

  },
  disabled: {
    accentColor: colors.mediumBlue,    
    backgroundColor: `${colors.veryLightGrey} !important`,
    border: `1px solid ${colors.darkGrey}`,
     "&:hover": {
      backgroundColor: `${colors.veryLightGrey} !important`,
      border: `1px solid ${colors.darkGrey}`,
      cursor: "default",
    },
  }
}));

export default styles;
